export default __webpack_public_path__ + "static/media/fire.7404eca7.svg";